import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'
import { FaEye } from 'react-icons/fa'

import {
  Btn,
  CustomDataTable,
  CustomDataTableHeader,
  CustomInputTextArea,
  CustomModal,
  InputText,
  Loading,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import CicloEntregaAcoesHttp from '../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'
import { errorHandler } from '../../../../services/util/error.service'
import { showMessageBox } from '../../../../store/actions/system.actions'

function ModalListaProdutos({ isVisible, onClose, delivery, dispatch }) {
  const [state, setState] = useState({
    items: [],
    globalFilter: '',
    isLoading: false,
    errorMessage: null,
    observacoes: {},
    isSaving: false,
    editModal: {
      show: false,
      item: null,
      observacao: '',
    },
  })

  const deliveryId = delivery && delivery.delivery_id ? delivery.delivery_id : null
  const deliveryIdentifier = delivery && delivery.identifier ? delivery.identifier : ''

  const editItem = state.editModal.item
  const editProductLabel = editItem ? `${editItem.product_code} - ${editItem.product_name}` : ''

  useEffect(() => {
    if (isVisible && deliveryId) {
      fetchItems(deliveryId)
    }
  }, [isVisible, deliveryId])

  useEffect(() => {
    if (!isVisible) {
      setState(prevState => ({
        ...prevState,
        items: [],
        globalFilter: '',
        isLoading: false,
        errorMessage: null,
        observacoes: {},
        isSaving: false,
        editModal: { show: false, item: null, observacao: '' },
      }))
    }
  }, [isVisible])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({ ...prevState, errorMessage: null }))
    }
  }, [state.errorMessage])

  const fetchItems = async id => {
    if (!id) return
    try {
      setState(prevState => ({ ...prevState, isLoading: true }))
      const items = await CicloEntregaAcoesHttp.getDeliveryItemsByDeliveryId(id)

      // Inicializar observações com os valores atuais dos itens
      const observacoes = {}
      items.forEach(item => {
        observacoes[item.id] = item.observacao || ''
      })

      setState(prevState => ({ ...prevState, items, observacoes, isLoading: false }))
    } catch (e) {
      setState(prevState => ({
        ...prevState,
        isLoading: false,
        errorMessage: errorHandler(e),
      }))
    }
  }

  const onChangeObservacao = (itemId, value) => {
    setState(prevState => ({
      ...prevState,
      observacoes: {
        ...prevState.observacoes,
        [itemId]: value,
      },
    }))
  }

  const onOpenEditModal = item => {
    setState(prevState => ({
      ...prevState,
      editModal: {
        show: true,
        item,
        observacao: prevState.observacoes[item.id] || item.observacao || '',
      },
    }))
  }

  const onCloseEditModal = () => {
    setState(prevState => ({
      ...prevState,
      editModal: { show: false, item: null, observacao: '' },
    }))
  }

  const onSalvarObservacaoModal = async () => {
    if (!state.editModal.item) return

    try {
      setState(prevState => ({ ...prevState, isSaving: true }))

      // Fazer a requisição diretamente
      await CicloEntregaAcoesHttp.updateDeliveryItemObservacao({
        delivery_item_id: state.editModal.item.id,
        observacao: state.editModal.observacao,
      })

      // Atualizar os estados locais
      setState(prevState => ({
        ...prevState,
        items: prevState.items.map(item =>
          item.id === state.editModal.item.id
            ? { ...item, observacao: state.editModal.observacao }
            : item,
        ),
        observacoes: {
          ...prevState.observacoes,
          [state.editModal.item.id]: state.editModal.observacao,
        },
        editModal: { show: false, item: null, observacao: '' },
        isSaving: false,
      }))

      dispatch(showMessageBox('Observação atualizada com sucesso.', null))
    } catch (e) {
      setState(prevState => ({
        ...prevState,
        isSaving: false,
        errorMessage: errorHandler(e),
      }))
    }
  }

  const onSalvarObservacoes = async () => {
    try {
      setState(prevState => ({ ...prevState, isSaving: true }))

      // Encontrar observações que foram alteradas
      const promises = state.items
        .filter(item => {
          const newObservacao = state.observacoes[item.id] || ''
          const oldObservacao = item.observacao || ''
          return newObservacao !== oldObservacao
        })
        .map(item =>
          CicloEntregaAcoesHttp.updateDeliveryItemObservacao({
            delivery_item_id: item.id,
            observacao: state.observacoes[item.id] || '',
          }),
        )

      if (promises.length === 0) {
        setState(prevState => ({ ...prevState, isSaving: false }))
        dispatch(showMessageBox('Nenhuma alteração para salvar.', null))
        return
      }

      await Promise.all(promises)

      // Atualizar os itens no estado
      const updatedItems = state.items.map(item => ({
        ...item,
        observacao: state.observacoes[item.id] || '',
      }))

      setState(prevState => ({
        ...prevState,
        items: updatedItems,
        isSaving: false,
      }))

      dispatch(showMessageBox('Observações atualizadas com sucesso.', null))
    } catch (e) {
      setState(prevState => ({
        ...prevState,
        isSaving: false,
        errorMessage: errorHandler(e),
      }))
    }
  }

  const priceBodyTemplate = item => {
    return item.valor_item
      ? item.valor_item.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
      : item.valor_item
  }

  const weightBodyTemplate = item => {
    const weight = item.total_weight || 0
    return weight.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }

  const observacaoBodyTemplate = item => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
        <div style={{ flex: 1 }}>
          <InputText
            value={state.observacoes[item.id] || ''}
            onChange={value => onChangeObservacao(item.id, value)}
            placeholder="Digite a observação"
            marginTop={0}
          />
        </div>
        <span
          onClick={() => onOpenEditModal(item)}
          title="Expandir observação"
          style={{
            flexShrink: 0,
            fontSize: '1.3rem',
            color: '#14B0BF',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: '0 4px',
          }}
        >
          <FaEye />
        </span>
      </div>
    )
  }

  return (
    <CustomModal
      header="Lista de Produtos"
      isVisible={isVisible}
      onClose={onClose}
      maximizable={true}
      width="95vw"
      contentStyle={{ height: '90vh', overflow: 'auto' }}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <InputText
            label="Identificador"
            marginTop={0}
            value={deliveryIdentifier}
            onChange={() => {}}
            disabled={true}
          />
        </div>
        <div
          className="p-col-6"
          style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
        >
          <Btn onClick={onSalvarObservacoes} isLoading={state.isSaving} disabled={state.isSaving}>
            Salvar Observações
          </Btn>
        </div>
        <div className="p-col-12" style={{ marginTop: 2 }}>
          <span style={{ color: '#14B0BF', fontSize: '0.9rem' }}>Lista de Produtos:</span>
        </div>
        <div className="p-col-12">
          {state.isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <>
              <CustomDataTable
                value={state.items}
                globalFilter={state.globalFilter}
                header={
                  <CustomDataTableHeader
                    value={state.globalFilter}
                    onChange={value =>
                      setState(prevState => ({ ...prevState, globalFilter: value }))
                    }
                  />
                }
                paginator={true}
                rows={10}
                rowHover={true}
                className="auto-layout"
              >
                <Column field="product_code" header="Código" style={tableCellCentered(200)} />
                <Column field="product_name" header="Produto" />
                <Column
                  field="total_weight"
                  header="Peso"
                  body={weightBodyTemplate}
                  style={tableCellCentered()}
                />
                <Column
                  field="valor_item"
                  header="Valor R$"
                  body={priceBodyTemplate}
                  style={tableCellCentered()}
                />
                <Column field="volume" header="Volume" style={tableCellCentered()} />
                <Column field="units" header="Unidade" style={tableCellCentered()} />
                <Column field="observacao" header="Observação" body={observacaoBodyTemplate} />
              </CustomDataTable>
            </>
          )}
        </div>
      </div>
      <CustomModal
        header="Editar Observação"
        isVisible={state.editModal.show}
        onClose={onCloseEditModal}
        width={600}
      >
        <form className="p-grid">
          <div className="p-col-12">
            <InputText
              label="Produto"
              marginTop={0}
              value={editProductLabel}
              onChange={() => {}}
              disabled={true}
            />
          </div>
          <div className="p-col-12">
            <CustomInputTextArea
              label="Observação"
              marginTop={0}
              rows={6}
              value={state.editModal.observacao}
              onChange={value =>
                setState(prevState => ({
                  ...prevState,
                  editModal: { ...prevState.editModal, observacao: value },
                }))
              }
            />
          </div>
          <div className="p-col-12">
            <Btn
              onClick={onSalvarObservacaoModal}
              isLoading={state.isSaving}
              disabled={state.isSaving}
            >
              Salvar
            </Btn>
          </div>
        </form>
      </CustomModal>
    </CustomModal>
  )
}

export default connect()(ModalListaProdutos)
